import script from "./ApplyDrawDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyDrawDialog.vue?vue&type=script&setup=true&lang=js"

import "./ApplyDrawDialog.vue?vue&type=style&index=0&id=9075eea4&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9075eea4"]])

export default __exports__